import Modal from '@components/v2/ui/Modal/Modal';
import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import { FieldValues } from 'react-hook-form';
import LangEnum from '../../../../../lang/LangEnum';
import { useTranslation } from '../../../../translation/TranslationContext';
import { CopyOrderProductsBaseModalProps } from './CopyOrderProductsBaseModal.interfaces';

const CopyOrderProductsBaseModal = <T extends FieldValues>({
  isOpen,
  form,
  title,
  question,
  description,
  hint,
  copyButtonLabel,
  children,
  isSubmitDisabled,
  submitButtonTooltipMessage,
  handleSubmit,
  onClose,
}: CopyOrderProductsBaseModalProps<T>) => {
  const { translate } = useTranslation();

  const handleClose = () => {
    if (form.formState.isSubmitting) {
      return;
    }

    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      size="expanded"
      header={{ title }}
      onClose={handleClose}
      onExited={() => form.reset()}
      footer={{
        primaryAction: {
          label: form.formState.isSubmitting ? LangEnum.GLOBAL_COPYING : copyButtonLabel,
          isDisabled: isSubmitDisabled,
          isLoading: form.formState.isSubmitting,
          tooltipMessage: submitButtonTooltipMessage,
          onClick: form.handleSubmit(handleSubmit),
        },
        secondaryAction: { label: LangEnum.GLOBAL_CANCEL_LABEL, onClick: handleClose },
      }}
    >
      <Stack sx={{ gap: 3 }}>
        <Stack sx={{ gap: 1.5, pl: 0.5 }}>
          <Typography variant="overline" color="text.secondary">
            {translate(question)}
          </Typography>
          <Stack sx={{ gap: 0.5 }}>
            <Typography color="text.secondary">{translate(description)}</Typography>
            {hint && <Typography color="text.secondary">{translate(hint)}</Typography>}
          </Stack>
        </Stack>
        {children}
      </Stack>
    </Modal>
  );
};

export default CopyOrderProductsBaseModal;
